<form [formGroup]="rentalProperty" class="form-rental-property">
  <div class="form-row">
    <div class="form-col">
      <mat-form-field class="mat-form-field-100" appearance="outline">
        <mat-label style="font-size: 16px !important">Rental property street address</mat-label>
        <input matInput class="form-outline form-control" placeholder="Rental property street address"
          formControlName="propertyStreetAddress" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
            (onSelectionChange)="selectPlace(suggestion)">
            {{ suggestion.description }}
          </mat-option>
        </mat-autocomplete>
        <mat-error>Rental property street address is required</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label style="font-size: 16px !important">Apt/Unit/Suite</mat-label>
        <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite" />
      </mat-form-field>
    </div>
  </div>
  <div class="form-row">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" placeholder="City" />
        <mat-error>City is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-col">
      <mat-form-field class="readonly" appearance="outline">
        <mat-label>State</mat-label>

        <mat-select [disabled]="true" formControlName="state" placeholder="State">
          @for (state of states; track state) {
          <mat-option [value]="state.id">{{ state.name }}</mat-option>
          }
        </mat-select>
        <mat-error>State is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>Zip Code</mat-label>
        <input matInput formControlName="zipCode" placeholder="Zip Code" />
        <mat-error
          *ngIf="this.rentalProperty.get('zipCode')?.errors?.['pattern'] && (rentalProperty.get('zipCode')?.touched)">Zip
          Code is invalid</mat-error>

        <mat-error
          *ngIf="this.rentalProperty.get('zipCode')?.errors?.['required'] && (rentalProperty.get('zipCode')?.touched)">Zip
          Code is required</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>Started renting</mat-label>
        <input matInput formControlName="startedRenting" [matDatepicker]="picker" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>Started renting is required</mat-error>
      </mat-form-field>
    </div>
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>Filing frequency</mat-label>
        <mat-select formControlName="filingFrequency" matNativeControl required>
          <mat-option value="M">Monthly</mat-option>
          <mat-option value="Q">Quarterly</mat-option>
        </mat-select>
        <mat-error>Filing frequency is required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="form-row" *ngIf="this.isMotelHotel">
    <div class="form-col">
      <mat-form-field appearance="outline" requiered>
        <mat-label style="font-size: 16px !important">Name on the business sign</mat-label>
        <input matInput formControlName="businessName" placeholder="Name on the business sign" required />
        <mat-error>Name on the business sign is required</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row" *ngIf="this.isMotelHotel">
    <div class="form-col">
      <mat-form-field appearance="outline" requiered>
        <mat-label style="font-size: 16px !important">Website url</mat-label>
        <input matInput formControlName="webUrl" placeholder="Website url" />
        <mat-error>Website url is invalid</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
    <div class="form-col">
      <div class="row align-item-center gap-10">
        <mat-checkbox formControlName="usePlatformToRent" color="primary" class="primary">
          I don’t use any platform to rent out my property
        </mat-checkbox>
        <mat-icon aria-hidden="false"
          matTooltip="In an effort to ensure compliance of all short term/vacation rentals we ask that you provide the rental advertisements and websites that you utilize. Example: airbnb.com/rooms/12345678">info_outline</mat-icon>

      </div>
    </div>
  </div>
  <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>If you use a digital platform, paste link here</mat-label>
        <input matInput formControlName="platFormLink" placeholder="If you use a digital platform, paste link here" />
        
        <mat-error *ngIf="rentalProperty.get('platFormLink')?.touched">
          <span *ngIf="rentalProperty.get('platFormLink')?.hasError('required') ">
            You must select the checkbox or paste the digital platform
            link
          </span>
          <span *ngIf="!rentalProperty.get('platFormLink')?.hasError('required')">
            Platform url is invalid
          </span>
        </mat-error>

      </mat-form-field>

    </div>

  </div>
  <div class="form-row" *ngIf="this.isIndividualPropertyOwner">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label style="font-size: 16px !important">Rental Property Business Name</mat-label>
        <input matInput formControlName="rentalPropertyBusiness" placeholder="Rental Property Business Name"
          [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let suggestion of propertySuggestions" [value]="suggestion.name"
            (onSelectionChange)="selectProperty(suggestion)">
            {{ suggestion.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</form>